import "./Work.css"
// import cover from "./assets/work1/appCoverBlackdoor.jpg"
// import logo from "./assets/work1/appLogoBlackdoor.jpg"
// import logo2 from "./assets/work2/work2Logo.png"
// import cover2 from "./assets/work2/invoiceCover.png"

export default function Work(props) {
    
    return (
        <>
        <div className="work" id="products">
            <p className="work-title">Don't just believe our words. See our <span className="orange-text">work.</span></p>
            <p className="work-subtitle">Explore some of the products we have built.</p>
            <div className="work-card-container">
            {props.data.map((el)=>{
                return (
                <>
                <div className="work-card">
            <a href={el.appLink} target="_blank" rel="noreferrer">
                <div>
                    <img className="work-card-img" src={el.coverImage} alt={`${el.name} cover`}></img>
                </div>
                <div className="work-desc-cont">
                    <img className="work-icon" src={el.iconImage} alt={`${el.name} icon`}></img>
                    <div className="work-text-cont">
                        <span className="work-name-1">{el?.name}</span>
                        <span className="work-desc-1">{el?.description}</span>
                    </div>
                </div>
            </a>
            </div>
                </>)
            })}
            </div>
            {/* <div className="work-card">
            <a href="https://play.google.com/store/apps/details?id=com.edit.download.video.grabnedit&hl=en" target="_blank">
                <div>
                    <img className="work-card-img" src={cover}></img>
                </div>
                <div className="work-desc-cont">
                    <img className="work-icon" src={logo}></img>
                    <div className="work-text-cont">
                        <span className="work-name-1">{props?.data?.name}</span>
                        <span className="work-desc-1">{props?.data?.description}</span>
                    </div>
                </div>
            </a>
            </div>
            <div className="work-card">
            <a href="https://play.google.com/store/apps/details?id=com.edit.download.video.grabnedit&hl=en" target="_blank">
                <div>
                    <img className="work-card-img" src={cover2}></img>
                </div>
                <div className="work-desc-cont">
                    <img className="work-icon" src={logo2}></img>
                    <div className="work-text-cont">
                        <span className="work-name-1">{props?.data?.name}</span>
                        <span className="work-desc-1">{props?.data?.description}</span>
                    </div>
                </div>
            </a>
            </div> */}
        </div>
        </>
    )
} 
